<script setup>
    import { useWebStore } from '~/store/web';
    const store = useWebStore();
    store.chosenTab = store.sites[8].url
    const tenderPageVisible = ref(false);
    const chosenTender = ref({});

    // A store nyelvfüggetlen alapadataira (id, who, title) az aktuális nyelv tenderInfo
    // mezői kerülnek rá: p1-p6, címke-felülírások (l1, l5), esetleg lefordított title.
    const finishedTenders = computed(() => store.finishedTenders.map(tender => ({
        ...tender,
        ...store.locale.current.tenderInfo.find(t => t.id === tender.id),
    })));

    function showTender(tender){
        chosenTender.value = tender
        tenderPageVisible.value = true;
    }
</script>
<template>
        <div class=" bg-white overflow-y-auto">
            <div class="w-5/6 pt-5 pb-16 mx-auto text-left">
                <h1 class="InterExtraBold text-3xl md:text-4xl my-8">{{store.getLocaleString('t8')}}</h1>
                <div class="flex flex-col gap-10 lg:flex-row lg:items-start">
                    <div class="flex flex-col gap-6 lg:order-last lg:w-1/4">
                        <img class="w-full max-w-md" src="/szechenyi_terv_plusz-poliol-540x.jpg" alt="Széchenyi Terv Plusz">
                        <img class="w-1/2 max-w-xs lg:w-full" src="/szechenyi2020_logo.png" alt="Széchenyi 2020">
                    </div>
                    <div class="flex flex-col gap-14 lg:w-3/4">
                        <div v-for="tender of finishedTenders" v-bind:key="tender.id"
                            class="grid gap-y-1 sm:grid-cols-[auto_1fr] sm:gap-x-8 sm:gap-y-3">
                            <span class="font-bold">{{ store.getLocaleString('t2') }}</span>
                            <span class="mb-2 sm:mb-0">{{ tender.id }}</span>
                            <span class="font-bold">{{ store.getLocaleString('t4') }}</span>
                            <span class="mb-2 sm:mb-0">{{ tender.who }}</span>
                            <span class="font-bold">{{ store.getLocaleString('t6') }}</span>
                            <span class="mb-2 sm:mb-0">{{ tender.title }}</span>
                            <UButton class="w-fit" @click="showTender(tender)"><b>{{ store.getLocaleString('t9') }}</b></UButton>
                        </div>
                    </div>
                </div>
            </div>
            <ClientOnly>
                <UModal v-model="tenderPageVisible"
                        :ui="{width:'w-full sm:max-w-3xl',margin: 'sm:my-24', padding: 'p-4 sm:p-2'}"
                        >
                    <div class="p-4 w-full mx-auto h-2/6 flex flex-col gap-5">
                        <UButton color="gray" variant="ghost" icon="i-heroicons-x-mark-20-solid" size="xl" class="ml-auto mr-1 p-0" @click="tenderPageVisible=false" />
                        <h3 class="text-3xl">{{ chosenTender.title }}</h3>
                        <p><b>{{store.getLocaleString('t4')}}</b> {{ chosenTender.who }}</p>
                        <p><b>{{chosenTender.l1 || store.getLocaleString('t10')}}</b> {{ chosenTender.p1 }}</p>
                        <p><b>{{store.getLocaleString('t11')}}</b> {{ chosenTender.p2 }}</p>
                        <p class="whitespace-pre-line"><b>{{store.getLocaleString('t12')}}</b> {{ chosenTender.p3 }}</p>
                        <p v-if="chosenTender.p4" class="whitespace-pre-line">{{ chosenTender.p4 }}</p>
                        <p><b>{{chosenTender.l5 || store.getLocaleString('t13')}}</b> {{ chosenTender.p5 }}</p>
                        <p><b>{{store.getLocaleString('t2')}}</b> {{ chosenTender.id }}</p>
                        <p v-if="chosenTender.p6">{{ chosenTender.p6 }}</p>
                    </div>
                </UModal>
            </ClientOnly>


        </div>
        <FooterComp/>
</template>
